// extracted by mini-css-extract-plugin
module.exports = {"form":"I_form__sXjNd"};